import { FC, useContext } from "react";
import { useFormContext } from "react-hook-form";
import TGButton from "src/components/ui/TGButton";
import { TestRegistryContext } from "../../store/testRegistryContext";
import { IAnswer } from "src/pages/DashboardPage/acadia/components/Tests/types";
import { answersRegistry, questionsRegistry, testRegistry } from "src/api/config/notifications.config";
import { deleteItemRequest, updateItemRequest } from "src/modules/spItems/api";
import { setAddQuestion, setOpenForm, setTest } from "../../store/testRegistryActions";

interface IProps {
  question: any;
}

export const FormFooter: FC<IProps> = ({ question }) => {
  const {
    watch,
    formState: { isValid, isDirty }
  } = useFormContext();
  const { state, dispatchTestRegistry } = useContext(TestRegistryContext);

  const answers: IAnswer[] = watch("AnswersTest");

  const disabledButton = !isValid || !isDirty || answers.length < 2 || !answers?.filter((answer: IAnswer) => answer.IsCorrect).length;

  const closeForm = () => {
    dispatchTestRegistry(setOpenForm(false));
    dispatchTestRegistry(setAddQuestion(false));
  };

  const deleteQuestion = async () => {
    const questionID = question.ID;
    const answersID = question.Answers.map((answer: IAnswer) => answer.ID);

    try {
      await deleteItemRequest({ listName: questionsRegistry, ID: questionID });
      await deleteItemRequest({ listName: answersRegistry, ID: answersID });
      dispatchTestRegistry(
        setTest({
          ...state.test,
          QuestionsID: state.test.QuestionsID.filter(id => id !== questionID)
        })
      );
      closeForm();
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className="flex justify-between">
      <TGButton onClick={closeForm}>Отмена</TGButton>
      <div className="flex gap-[10px]">
        {!state.addQuestion ? <TGButton onClick={deleteQuestion}>Удалить</TGButton> : null}
        <TGButton type="submit" color="bluedark" disabled={disabledButton}>
          Сохранить
        </TGButton>
      </div>
    </div>
  );
};
